import React from "react";
import { ArrowUpRight } from "lucide-react";
import PageShell, { PageHero } from "./PageShell";
import { insights } from "../mock";

import { tr } from "../i18n";
export default function InsightsPage() {
  return (
    <PageShell>
      <PageHero
        eyebrow={tr("Insights")}
        title={tr("Insights from R&H")}
        intro={tr("Market commentary, guides and news to help you make the most of your cash.")}
      />
      <section className="bg-white py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-5 md:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {insights.map((post, i) => (
              <article key={i} className="group cursor-pointer rounded-2xl overflow-hidden ring-1 ring-[#0b1f3a]/8 bg-[#f6f2e9]/30">
                <div className="overflow-hidden">
                  <img src={post.image} alt={post.title} className="w-full h-52 object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <span className="text-[11px] uppercase tracking-widest text-[#c2a15a] font-medium">{post.tag}</span>
                  <h3 className="font-display text-[20px] text-[#0b1f3a] mt-2 leading-snug flex items-start gap-1">
                    {post.title}
                    <ArrowUpRight size={16} className="shrink-0 mt-1 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all text-[#c2a15a]" />
                  </h3>
                  <p className="text-[#0b1f3a]/60 text-[14px] mt-2 leading-relaxed">{post.excerpt}</p>
                  <p className="text-[#0b1f3a]/40 text-[12px] mt-4">{post.date}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}
